import React, {useCallback, useContext} from "react";
import { Link } from "react-router-dom";

import {Conjunto} from "../../../../Components/Conjunto";

import {Button, Col, Empty, Form, Grid, Input, Row, Select, Tag} from "antd";
import {Ordenar} from "../../../../Utils/Ordenacao";
import {ResponsiveAntdTable} from "../../../../Components/ResponsiveAntdTable";
import {StatusDaViagemService} from "../../../../Services/Domain/Viagem/StatusDaViagemService";
import {_TypeViagemSemRecursao, TypeViagem} from "../../../../Models/Domain/Viagem/Viagem";
import {useForm, useWatch} from "antd/lib/form/Form";
import {useQuery} from "@tanstack/react-query";
import {EnumStatusDaViagem, TypeStatusDaViagem} from "../../../../Models/Domain/Viagem/StatusDaViagem";
import {SessaoARContext} from "../../../Contexts/SessaoContext";
import {ParametrosDaSessaoARContext, ParametrosDaSessaoDaEscola} from "../../../Views/Sistema/ParametrosDaSessao";
import {EnumTipoUsuario, SessaoARDaEscola} from "../../../../Models/Domain/AreaRestrita/Sessao";
import {Formatacoes} from "../../../../Utils/Formatacao";
import {TypeDestino} from "../../../../Models/Domain/Viagem/Destino";
import InputDate from "@/Components/Base/Input/InputDate";

export const ListagemDeViagensDaEscola: React.FC<{
    aoSelecionarInscricoes?: (viagem: TypeViagem) => any,
    hrefDoBotaoInscricoes?: (viagem: TypeViagem) => string | void
}> = (props) => {

    const tamanhoDaTela = Grid.useBreakpoint();

    const SessaoAR = useContext(SessaoARContext);
    const ParametrosDaSessaoAR = useContext(ParametrosDaSessaoARContext) as ParametrosDaSessaoDaEscola;

    const sessaoValida = SessaoAR?.sessao?.tipoDeUsuario === EnumTipoUsuario.Escola && ParametrosDaSessaoAR.tipoDeUsuario == EnumTipoUsuario.Escola;

    interface IFiltro {
        destino?: TypeViagem["destino"],
        titulo?: TypeViagem["titulo"],
        de?: TypeViagem["inicio"],
        ate?: TypeViagem["fim"],
        status?: TypeViagem["status"],
        ativo?: TypeViagem["ativo"],
    }

    const [form] = useForm<IFiltro>();
    const filtro = useWatch([], form);

    const viagensDisponiveis: TypeViagem[] = (SessaoAR?.sessao as SessaoARDaEscola)?.info?.viagens ?? [];

    const destinosDisponiveis: TypeDestino[] = (
        viagensDisponiveis.filter((v) => v.destino != undefined).map((v) => v.destino!).reduce((prev: TypeDestino[], cur: TypeDestino) => {
            return prev.find((d) => d.codigo == cur.codigo) ? prev : [...prev, cur]
        }, [] as TypeDestino[])
    )

    const statusDisponiveis = useQuery({
        queryKey: ["listarStatusDisponiveis"],
        queryFn: () => new StatusDaViagemService().listarStatusDisponiveis(),
        enabled: true,
    });


    const filterPipe = useCallback((item: TypeViagem): boolean => {
        if (filtro == undefined) return true;

        const fDe = (Formatacoes.paraData(filtro.de));
        const fAte = (Formatacoes.paraData(filtro.ate));

        const fInicio = (Formatacoes.paraData(item.inicio));
        const fFim = (Formatacoes.paraData(item.fim));

        return (
            // ( (filtro.ativo === undefined) || ( item.ativo === filtro.ativo ) ) &&
            ((filtro.destino?.codigo) === undefined || (item.destino?.codigo === filtro.destino?.codigo)) &&
            ((filtro.titulo === undefined) || (item.titulo !== undefined && item.titulo.toLowerCase().includes(filtro.titulo.toLowerCase()))) &&
            ((fDe === undefined) || (fInicio !== undefined && fInicio >= fDe)) &&
            ((fAte === undefined) || (fFim !== undefined && fFim <= fAte)) &&
            ((filtro.status !== undefined && filtro.status.codigo === undefined) || (item.status?.codigo === filtro.status?.codigo)) &&
            true
        )

    }, [filtro]);

    if (sessaoValida == false) return <Empty description="A sessão atual não corresponde a uma sessão do tipo escola" />;

    return <React.Fragment>
        <Form<IFiltro> form={form} layout='vertical' autoComplete='off'>
            <Row gutter={16}>

                <Col xs={24} md={24} xl={9}>
                    <Form.Item<IFiltro> name={["titulo"]} label="Título">
                        <Input placeholder="Todos" />
                    </Form.Item>
                </Col>


                <Col xs={24} md={6} xl={3}>
                    <Form.Item<IFiltro> name={["status", "codigo"]} label="Status">
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={statusDisponiveis.data?.data.map((item) => ({value: item.codigo, label: item.descricao}))}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6} xl={4}>
                    <Form.Item<IFiltro> name={["destino", "codigo"]} label="Destino">
                        <Select
                            allowClear
                            placeholder={"Todos"}
                            options={destinosDisponiveis.map((item) => ({value: item.codigo, label: item.nome}))}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6} xl={4}>
                    <Form.Item<IFiltro> name={["de"]} label="De">
                        <InputDate style={{width: "100%"}} placeholder="Todos" />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6} xl={4}>
                    <Form.Item<IFiltro> name={["ate"]} label="Até">
                        <InputDate style={{width: "100%"}} placeholder="Todos" />
                    </Form.Item>
                </Col>

            </Row>
        </Form>

        <Row>
            <Col xs={24}>
                <ResponsiveAntdTable<TypeViagem, _TypeViagemSemRecursao>
                    bordered
                    rowKey={(k) => k.codigo!}
                    locale={{emptyText: 'Nenhuma viagem encontrada.'}}
                    loading={false}
                    dataSource={viagensDisponiveis.filter(filterPipe)}
                    addTitleOn="lg"
                    columns={[
                        {
                            title: "Titulo",
                            dataIndex: ["titulo"],
                            breakpoints: {xs: 24, sm: 12, xl: 4},
                            key: "viagem-titulo",
                            sorter: (a, b) => Ordenar.String(a.titulo, b.titulo),
                        },
                        {
                            title: "Destino",
                            dataIndex: ["destino", "nome"],
                            breakpoints: {xs: 24, sm: 12, xl: 4},
                            key: "viagem-destino",
                            sorter: (a, b) => Ordenar.String(a.destino?.nome, b.destino?.nome),
                        },
                        {
                            title: "Prazo de inscrição",
                            dataIndex: ["prazoDeInscricao"],
                            breakpoints: {xs: 24, sm: 8, xl: 4},
                            key: "viagem-prazo-inscricao",
                            sorter: (a, b) => Ordenar.Data(a.prazoDeInscricao, b.prazoDeInscricao),
                            render: (val) => {
                                return <>{Formatacoes.paraData(val)?.toLocaleDateString() ?? "N/A"}</>
                            },
                        },
                        {
                            title: "Datas",
                            breakpoints: {xs: 24, sm: 8, xl: 4},
                            key: "viagem-datas",
                            render: (_, item) => {
                                let inicio = Formatacoes.paraData(item.inicio)
                                let fim = Formatacoes.paraData(item.fim)
                                return <>{inicio?.toLocaleDateString() ?? "N/A"} : {fim?.toLocaleDateString() ?? "N/A"}</>
                            },
                        },
                        {
                            title: "Status",
                            dataIndex: ["status"],
                            breakpoints: {xs: 24, sm: 8, xl: 3},
                            key: "viagem-status",
                            render: (v: TypeStatusDaViagem) => {

                                if (v.codigo == EnumStatusDaViagem.EM_ANDAMENTO) {
                                    return <Tag style={{width: "min-content"}} color="green">{v.descricao}</Tag>
                                }

                                if (v.codigo == EnumStatusDaViagem.ENCERRADA) {
                                    return <Tag style={{width: "min-content"}} color="blue">{v.descricao}</Tag>
                                }

                                if (v.codigo == EnumStatusDaViagem.CANCELADA) {
                                    return <Tag style={{width: "min-content"}} color="red">{v.descricao}</Tag>
                                }

                                return v.descricao
                            },
                            sorter: (a, b) => Ordenar.String(a.status?.descricao, b.status?.descricao),
                        },
                        {
                            title: "Ações",
                            key: "viagem-acoes",
                            noResponsiveTitle: true,
                            breakpoints: {xs: 24, sm: 24, xl: 5},
                            render: (_, item) => {
                                return (
                                    <Conjunto
                                        style={{ justifyContent: tamanhoDaTela.sm ? "unset" : "center", display: "flex", flexWrap: "wrap" }}
                                        itens={[
                                            <Link
                                                to={props.hrefDoBotaoInscricoes?.(item) ?? "#"}
                                                onClick={(e) => !props.hrefDoBotaoInscricoes && e.preventDefault()}
                                            >
                                                <Button
                                                    type="default"
                                                    size="small"
                                                    onClick={() => {
                                                        props.aoSelecionarInscricoes?.(item);
                                                    }}
                                                >
                                                    Inscrições
                                                </Button>
                                            </Link>
                                        ]}
                                    />
                                );
                            }
                        },

                    ]}
                />
            </Col>
        </Row>

    </React.Fragment >

}
